import { ApiService } from "../model/Api.model";
import { AxiosInstance } from "axios";
import { ISpecialProject } from "../interface/specialProject/ISpecialProject";
import { IBaseResponse } from "../interface/IBaseResponse";
import { IQuestion } from "../interface/Questionnaire/IQuestion";
import { IFillSelect } from '../interface/IFillSelect';
import { IEditSpecialProject } from '../interface/specialProject/IEditSpecialProject';
import { ISpecialProjectUpdateTrades } from "../interface/specialProject/ISpecialProjectUpdateTrades";

enum SpecialProjectEnum {
  getById = "/",
  getAll = "/get-all",
  getSelect = "/get-select",
  createSpecialProject = "/",
  createTradesBySpecialProject = "/create-trades?idSpecialProject=",
  sendToLawFirmValidateProccess = "/send-to-law-firm-validate-proccess?idSpecialProject=",
  runBCheck = "/run-bcheck?idSpecialProject=",
  questionnaire = "/questionnaire",
  getTrades = "/get-trades/",
  updateTrades = "/update-trades/",
}

export default class SpecialProjectService extends ApiService {
  constructor(restClient: AxiosInstance) {
    super(restClient, "/special-project");
  }

  public getAll = async (): Promise<ISpecialProject[]> => await this.GET(SpecialProjectEnum.getAll);
  public getSelect = async (): Promise<IFillSelect[]> => await this.GET(SpecialProjectEnum.getSelect);
  public getById = async (id: number): Promise<ISpecialProject> => await this.GET(SpecialProjectEnum.getById + id);
  public updateTrades = async (request: ISpecialProjectUpdateTrades): Promise<IBaseResponse> => await this.POST(SpecialProjectEnum.updateTrades, request);
  public createSpecialProject = async (data: IEditSpecialProject): Promise<IBaseResponse> => await this.POST(SpecialProjectEnum.createSpecialProject, data);
  public createTradesBySpecialProject = async (id: number): Promise<IBaseResponse> => await this.POST(SpecialProjectEnum.createTradesBySpecialProject + id, null);
  public sendToLawFirmValidateProccess = async (id: number): Promise<IBaseResponse> => await this.POST(SpecialProjectEnum.sendToLawFirmValidateProccess + id, null);
  public runBCheck = async (id: number, isRerun: boolean): Promise<IBaseResponse> => await this.POST(SpecialProjectEnum.runBCheck + id + "&isRerun=" + isRerun, null);
  public getQuestionnaireModel = async (id: number): Promise<IQuestion[]> => await this.GET(`${SpecialProjectEnum.questionnaire}/${id}`);
  public saveQuestionnaire = async (id: number, questionnaire: IQuestion[]) => await this.POST(`${SpecialProjectEnum.questionnaire}/${id}`, { questionnaire });
  public getTrades = async (specialProjectId: number) => await this.GET(SpecialProjectEnum.getTrades + specialProjectId);
}
